import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getServices = createAsyncThunk('users/getServices', async (__, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/services`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// GET ALL SERVICES BY RENTAL LOCATION
export const getServicesByRentalLocation = createAsyncThunk(
  'rentalLocation/getServicesByRentalLocation',
  async (location_id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/location/${location_id}/subservices`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
    }
  },
);
